import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useWizardNavigation } from 'hooks/useWizardNavigation';
import { WizardRoutesEnum } from 'utils/actions';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

export const BackButton = () => {
  const { t } = useTranslation();
  const { back, currentScreen } = useWizardNavigation();

  return (
    <Button
      variant="outlined"
      size="large"
      onClick={back}
      disabled={currentScreen === WizardRoutesEnum.PrivateData}
      startIcon={<ArrowBackOutlinedIcon />}
    >
      {t('wizard.actions.back')}
    </Button>
  );
};
